<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="lg"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    title="Detalhes do carrinho abandonado"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12" class=" text-center">
        <span class="font-weight-bold fs-18">Produtos</span>
      </b-col>
      
      <b-col cols="12" class="mt-2 mb-3">
        <b-table-simple hover small responsive>
          <b-thead>
            <b-tr variant="primary" class="border-0">
              <b-th>Nome</b-th>
              <b-th>Preço</b-th>
              <b-th>Quantidade</b-th>
              <b-th>Total</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(product, index) in fields.products" :key="index">
              <b-td>{{ product.name }}</b-td>
              <b-td>{{ formatNumber(product.price) }}</b-td>
              <b-td>{{ product.quantity }}</b-td>
              <b-td>{{ formatNumber(product.totalPrice) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    
      <b-col cols="4">
        <Info label="Valor do frete" :value="formatNumber(fields.shipping)" />
      </b-col>
      <b-col cols>
        <Info label="Valor Total da compra" :value="formatNumber(fields.totalValue)" />
      </b-col>
 
      <b-col cols="12" class="mt-5 mb-4 text-center">
        <span class="font-weight-bold fs-18">Dados do cliente</span>
      </b-col>
      <b-col cols="4">
        <Info label="Nome do cliente" :value="fields.client.name" />
      </b-col>
      <b-col cols="">
        <Info label="Celular" :value="fields.client.cellphone" />
      </b-col>
      <b-col cols="">
        <Info label="E-mail" :value="fields.client.email" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="RG" :value="fields.client.rg" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="CPF" :value="fields.client.cpf" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="Criado em" :value="fields.client.createdAt" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatNumber } from '@/utils';

import makeToast from '@/mixins/makeToast';

import Info from '../Inputs/Info.vue';

export default {
  name: 'OrderDetailsCart',
  mixins: [makeToast],
  props: {
    shopkeepersIds: Array,
  },
  data() {
    return {
      loading: false,
      orderId: 0,
      open: false,
      fields: this.defaultOrderDetails(),
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    formatNumber,
    ...mapActions('shopkeeper', ['getOrderDetails']),
    toggleOpen({ orderId = 0 }) {

      this.open = !this.open;
      this.orderId = orderId;

      this.get();
    },
    get() {
      if (this.loading || !this.orderId) return;

      this.loading = true;

      this.getOrderDetails({
        orderId: this.orderId,
        userId: this.dadosUsuario.id,
        shopkeepersIds: this.shopkeepersIds || []
      })
        .then((response) => {
          this.fields = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    defaultOrderDetails() {
      return {
        totalValue: '',
        shipping: '',
        paymentType: '',
        client: '',
        products: [],
      };
    },
  },
  components: {
    Info,
  },
};
</script>
